import {Box} from '@material-ui/core';
import Pagination from 'components/pagination';
import Table from 'components/tables/table';
import {autobind} from 'core-decorators';
import {formatDate, formatMoney, getMaxPage} from 'core/utils';
import React, {Component, Fragment} from 'react';

@autobind
export default class CreditsTable extends Component {
    state = {
        page: 0,
    };
    /**
     * @typedef {Object} Data
     * @property {number} id
     * @property {string} date
     * @property {string} description
     * @property {number} amount
     * @property {string} amountCurrency
     */
    /**
     * @typedef {Object} CreditsTableProps
     * @property {Array<Data>} data
     */

    /**
    * @type {CreditsTableProps}
    */
    props = {};
    rowsPerPage = 5;

    /** @param {number} page  */
    handlePageClick(page) {
        this.setState({page});
    }

    handlePreviousPage() {
        this.handlePageClick(this.state.page - 1);
    }

    handleNextPage() {
        this.handlePageClick(this.state.page + 1);
    }

    render() {
        const {data} = this.props;
        const startIndex = this.state.page * this.rowsPerPage;
        const endIndex = startIndex + this.rowsPerPage;
        const paginatedData = data.slice(startIndex, endIndex);
        return (
            <Fragment>
                <Table
                    data={paginatedData}
                    columns={[
                        {key: 'date', label: 'Fecha', format: formatDate},
                        {key: 'description', label: 'Detalle'},
                        {key: 'amount', label: 'Monto', render: row => formatMoney(row, 'amount')},
                    ]}
                />
                <Box mt={8}>
                    <Pagination
                        maxPage={getMaxPage(data.length, this.rowsPerPage)}
                        active={this.state.page}
                        handlePreviousPage={this.handlePreviousPage}
                        handleNextPage={this.handleNextPage}
                        handlePageClick={this.handlePageClick}
                        range={3}
                    />
                </Box>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./components/tables/credits-table.js